/* ════════════════════════════════════════════════════════════
   BUILDER TOUR — interactive first-time walkthrough
   ════════════════════════════════════════════════════════════ */
(function () {
  var TOUR_KEY = "dmb_tour_v1_done";
  var _step = 0, _active = false;
  var _dropHandler = null;
  var _globalClick = null; // document-level click gatekeeper

  function tab(n) {
    var b = document.querySelector(".dmb-icon-tab[data-tab='" + n + "']");
    if (b) b.click();
  }
  function undo() {
    var btn = document.getElementById("undoBtn");
    if (btn) btn.click();
  }

  var STEPS = [
    /* 1 */  { sel:"#addMorePhotosBtn",
               title:"📸 Add More Photos",
               desc:"Click this button to open the photo picker and add more photos from your device.",
               action:"click",  before:function(){ tab("images"); } },

    /* 2 */  { sel:"#dmbPicturesScrollArea",
               title:"🖼️ Your Photo Library",
               desc:"Your uploaded photos live here. Scroll through them — drag any photo onto a page or the cover to place it.",
               action:"info",  graphic:"scroll",  before:function(){ tab("images"); } },

    /* 3 */  { sel:".dmb-icon-tab[data-tab='cover']",
               title:"🎨 Open the Cover Designer",
               desc:"Click this tab to open the cover panel and start designing your book cover.",
               action:"click",  before:function(){ tab("images"); } },

    /* 4 */  { sel:".dmb-cover-zone-switcher",
               title:"Front · Back · Spine",
               desc:"Click Back or Spine to switch zones — each side can be designed independently.",
               action:"click",  before:function(){ tab("cover"); } },

    /* 5 */  { sel:"#coverColorSwatch",
               title:"🎨 Change the Cover Color",
               desc:"Click the color swatch and pick a background color for your cover.",
               action:"click" },

    /* 6 */  { sel:"#chooseCoverTemplateBtn",
               title:"📋 Choose a Cover Template",
               desc:"Click here to browse our pre-designed templates and apply one instantly.",
               action:"click" },

    /* 7 */  { sel:"#chooseCoverLayoutBtn",
               title:"🖼️ Cover Photo Layout",
               desc:"Click here to add a photo frame grid to your cover front or back.",
               action:"click" },

    /* 8 */  { sel:".dmb-icon-tab[data-tab='stickers']",
               title:"✨ Stickers, Icons & Maps",
               desc:"Click this tab to explore icons, magazine logos, stickers and world maps.",
               action:"click" },

    /* 9 */  { sel:"#dmbBrowseStickersBtn",
               title:"🏅 Cover Icons",
               desc:"Click here to open the cover icons panel.",
               action:"click",  before:function(){ tab("stickers"); } },

    /* 10 */ { sel:"#dmbMagIconsBtn",
               title:"📰 Magazine Icons",
               desc:"Click here to explore brand-style magazine logos.",
               action:"click" },

    /* 11 */ { sel:"#dmbStickersBtn",
               title:"🌟 Stickers",
               desc:"Click here to open the stickers library.",
               action:"click" },

    /* 12 */ { sel:"#addMyMapBtn",
               title:"🗺️ Add a Map",
               desc:"Click here to add a world map — then pin the places that matter to you.",
               action:"click",  before:function(){ tab("stickers"); } },

    /* 13 */ { sel:"#canvasTextBtn",
               title:"✏️ Add Text",
               desc:"Click the Text button to add a text label — then drag it wherever you like on the cover.",
               action:"click",  before:function(){ tab("cover"); } },

    /* 14 */ { sel:"#dmbPicturesScrollArea",
               title:"📷 Drop a Photo on the Cover",
               desc:"Drag any photo from the tray and drop it onto the cover. We'll remove it after.",
               action:"drop",   before:function(){ tab("images"); } },

    /* 15 */ { sel:"#thumbsRail",
               title:"📄 Click a Page",
               desc:"Click any page thumbnail to jump to that page and start designing it.",
               action:"click" },

    /* 16 */ { sel:"#dmbPicturesScrollArea",
               title:"🖼️ Drop a Photo on a Page",
               desc:"Drag a photo from the tray and drop it onto the page spread. We'll remove it after.",
               action:"drop",   before:function(){ tab("images"); } },

    /* 17 */ { sel:"#canvasTextBtn",
               title:"✏️ Text on a Page",
               desc:"Click the Text button to add a text label on the page — then drag it to position it.",
               action:"click" },

    /* 18 */ { sel:"#previewBtn",
               title:"👁️ Preview Your Book",
               desc:"Click Preview to review every page before confirming your order.",
               action:"click" }
  ];

  var _ov, _ring, _card, _cursor, _graphic, _curTarget;

  /* ── Build DOM ─────────────────────────────────────────────── */
  function _build() {
    ["_dmbTourOverlay","_dmbTourRing","_dmbTourCard",
     "_dmbTourCursor","_dmbTourGraphic","_dmbTourStyle"].forEach(function(id){
      var e = document.getElementById(id); if (e) e.remove();
    });

    // Visual-only overlay — pointer-events:none so clicks pass through to elements below.
    // Blocking is done at document level via _globalClick.
    _ov = document.createElement("div");
    _ov.id = "_dmbTourOverlay";
    _ov.style.cssText = "position:fixed;inset:0;z-index:99990;background:rgba(0,0,0,0.12);pointer-events:none;";

    _ring = document.createElement("div");
    _ring.id = "_dmbTourRing";
    _ring.style.cssText = "position:fixed;z-index:99992;border:3px solid #f59e0b;border-radius:10px;pointer-events:none;box-shadow:0 0 0 5px rgba(245,158,11,0.2);transition:left 0.3s,top 0.3s,width 0.3s,height 0.3s;display:none;";

    _cursor = document.createElement("div");
    _cursor.id = "_dmbTourCursor";
    _cursor.innerHTML = "👆";
    _cursor.style.cssText = "position:fixed;z-index:99994;font-size:26px;pointer-events:none;display:none;";

    _graphic = document.createElement("div");
    _graphic.id = "_dmbTourGraphic";
    _graphic.style.cssText = "position:fixed;z-index:99994;pointer-events:none;display:none;font-size:28px;";

    _card = document.createElement("div");
    _card.id = "_dmbTourCard";
    _card.style.cssText = "position:fixed;z-index:99995;width:420px;max-width:92vw;background:#fff;border-radius:16px;box-shadow:0 12px 48px rgba(0,0,0,0.22);padding:22px 24px 18px;pointer-events:all;transition:top 0.3s,left 0.3s;";
    _card.innerHTML =
      "<div style='display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:10px;'>" +
        "<div id='_dT_title' style='font-size:15px;font-weight:900;color:#111;line-height:1.3;'></div>" +
        "<button id='_dT_skip' style='background:none;border:none;font-size:12px;color:#bbb;cursor:pointer;white-space:nowrap;flex-shrink:0;padding:0;'>Skip tour ✕</button>" +
      "</div>" +
      "<div id='_dT_desc' style='font-size:13px;color:#555;line-height:1.6;margin-bottom:16px;'></div>" +
      "<div style='display:flex;align-items:center;justify-content:space-between;'>" +
        "<div id='_dT_counter' style='font-size:12px;color:#ccc;font-weight:700;'></div>" +
        "<div style='display:flex;gap:10px;'>" +
          "<button id='_dT_prev' style='padding:8px 16px;border-radius:9px;border:1px solid #e5e5e5;background:#f9f9f9;color:#555;font-size:12px;font-weight:800;cursor:pointer;'>← Back</button>" +
          "<button id='_dT_next' style='padding:8px 18px;border-radius:9px;border:none;background:#111;color:#fff;font-size:12px;font-weight:800;cursor:pointer;display:none;'>Next →</button>" +
        "</div>" +
      "</div>";

    var style = document.createElement("style");
    style.id = "_dmbTourStyle";
    style.textContent =
      "@keyframes _dmbRingPulse{0%,100%{box-shadow:0 0 0 5px rgba(245,158,11,0.2)}50%{box-shadow:0 0 0 12px rgba(245,158,11,0.05)}}" +
      "#_dmbTourRing{animation:_dmbRingPulse 1.6s ease-in-out infinite;}" +
      "@keyframes _dmbCursorTap{0%,100%{transform:scale(1)}50%{transform:scale(0.8) translate(-2px,-4px)}}" +
      "#_dmbTourCursor{animation:_dmbCursorTap 0.9s ease-in-out infinite;}" +
      "@keyframes _dmbHandScroll{0%{transform:translateX(0)}50%{transform:translateX(35px)}100%{transform:translateX(0)}}" +
      "#_dmbTourGraphic{animation:_dmbHandScroll 1.8s ease-in-out infinite;}";

    document.head.appendChild(style);
    document.body.appendChild(_ov);
    document.body.appendChild(_ring);
    document.body.appendChild(_cursor);
    document.body.appendChild(_graphic);
    document.body.appendChild(_card);

    document.getElementById("_dT_skip").onclick = function(){ _end(); };
    document.getElementById("_dT_next").onclick = function(){ _goto(_step + 1); };
    document.getElementById("_dT_prev").onclick = function(){ if(_step > 0) _goto(_step - 1); };

    // ── Document-level click gatekeeper ────────────────────────
    // Runs in capture phase (before anything else) on every click.
    // Blocks all clicks except: tour card buttons, and the current highlighted element.
    _globalClick = function(e) {
      if (!_active) return;

      var card = document.getElementById("_dmbTourCard");
      // Always allow clicks inside the tour card
      if (card && card.contains(e.target)) return;

      // Allow clicks inside any open modal/dialog so the user is never stuck
      var modals = [
        "dmbCoverTemplateModal",
        "dmb-cover-layout-modal",
        "dmbCustomStickerModal",
        "dmbMagIconModal",
        "dmbMapModal",
        "dmbPreviewOverlay",
        "dmb-frame-shape-picker",
        "dmbPhoneUploadModal",
        "_dmbTourCard"
      ];
      for (var mi = 0; mi < modals.length; mi++) {
        var m = document.getElementById(modals[mi]);
        if (m && m.style.display !== "none" && m.contains(e.target)) return;
      }
      // Also catch any dynamically created modal/overlay by checking if any
      // ancestor is position:fixed with a meaningful z-index
      if (e.target && e.target.closest) {
        var p = e.target;
        while (p && p !== document.body) {
          var style = window.getComputedStyle(p);
          var zi = parseInt(style.zIndex, 10);
          if (!isNaN(zi) && zi > 1000 && style.position === "fixed") return;
          p = p.parentElement;
        }
      }

      var s = STEPS[_step];

      // For "info" steps — block everything except the Next button (handled above)
      if (s.action === "info") {
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }

      // For "drop" steps — allow drags but block regular clicks elsewhere
      if (s.action === "drop") {
        // Allow clicks inside the photo tray (to start a drag)
        if (_curTarget && _curTarget.contains(e.target)) return;
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }

      // For "click" steps — allow ONLY the highlighted element
      if (_curTarget) {
        if (_curTarget.contains(e.target) || e.target === _curTarget) {
          // Valid tour click — advance after the element handles it
          setTimeout(function(){ _goto(_step + 1); }, 400);
          return; // let the click proceed normally
        }
      }

      // Block everything else
      e.stopImmediatePropagation();
      e.preventDefault();
    };
    document.addEventListener("click", _globalClick, true);
  }

  /* ── Show step ─────────────────────────────────────────────── */
  function _goto(idx) {
    if (!_active) return;
    if (idx >= STEPS.length) { _end(true); return; }
    _step = idx;
    var s = STEPS[idx];

    _curTarget = null;
    _graphic.style.display = "none";
    _cursor.style.display  = "none";

    if (_dropHandler) {
      document.removeEventListener("dragend", _dropHandler, true);
      _dropHandler = null;
    }

    if (s.before) { try { s.before(); } catch(e){} }

    // Wait for UI to update after tab switch
    setTimeout(function() {
      var el; try { el = document.querySelector(s.sel); } catch(e){}
      if (!el) { _goto(idx + 1); return; }

      _curTarget = el;

      var r = el.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        el.scrollIntoView({ behavior:"smooth", block:"center" });
      }

      setTimeout(function() {
        r = el.getBoundingClientRect();
        var vw = window.innerWidth, vh = window.innerHeight;

        // If element has zero size it's hidden inside a collapsed panel — skip
        if (r.width === 0 && r.height === 0) { _goto(idx + 1); return; }

        // Position ring (clamped to viewport)
        var rx = Math.max(0, r.left - 4);
        var ry = Math.max(0, r.top  - 4);
        var rw = Math.min(r.width  + 8, vw - rx);
        var rh = Math.min(r.height + 8, vh - ry);
        _ring.style.left = rx + "px";
        _ring.style.top  = ry + "px";
        _ring.style.width  = rw + "px";
        _ring.style.height = rh + "px";
        _ring.style.display = "block";

        if (s.graphic === "scroll") {
          _graphic.innerHTML = "🤚";
          _graphic.style.left = (rx + rw/2 - 14) + "px";
          _graphic.style.top  = (ry + rh/2 - 14) + "px";
          _graphic.style.display = "block";
        } else {
          // Place cursor pointing AT the element from below (or above if near bottom)
          var cursorSize = 28;
          var cx = rx + rw/2 - cursorSize/2; // horizontally centered on element
          var cy;
          if (ry + rh + cursorSize + 8 < vh) {
            // Enough room below — place cursor just below the ring
            _cursor.innerHTML = "👆";
            cy = ry + rh + 6;
          } else {
            // Near bottom — place cursor above the ring
            _cursor.innerHTML = "👇";
            cy = Math.max(0, ry - cursorSize - 6);
          }
          _cursor.style.left    = Math.max(0, Math.min(cx, vw - cursorSize)) + "px";
          _cursor.style.top     = cy + "px";
          _cursor.style.display = "block";
        }

        // Smart card position: above element if near bottom of screen
        var cardW = Math.min(420, vw * 0.92);
        var cardH = 155;
        var cardLeft = Math.max(12, Math.min(vw/2 - cardW/2, vw - cardW - 12));
        var cardTop  = r.bottom > vh * 0.55
          ? Math.max(12, ry - cardH - 14)
          : Math.min(Math.max(ry + rh + 14, vh * 0.55), vh - cardH - 12);
        _card.style.left   = cardLeft + "px";
        _card.style.top    = cardTop  + "px";
        _card.style.bottom = "auto";
        _card.style.transform = "none";

        document.getElementById("_dT_title").textContent   = s.title;
        document.getElementById("_dT_desc").textContent    = s.desc;
        document.getElementById("_dT_counter").textContent = (idx+1) + " / " + STEPS.length;

        var nb = document.getElementById("_dT_next");
        var pb = document.getElementById("_dT_prev");
        nb.textContent = idx === STEPS.length-1 ? "Finish ✓" : "Next →";
        nb.style.display = s.action === "info" ? "inline-block" : "none";
        pb.style.visibility = idx === 0 ? "hidden" : "visible";

        // Drop steps: listen for dragend anywhere on the document
        if (s.action === "drop") {
          _dropHandler = function() {
            if (!_active || _step !== idx) return;
            document.removeEventListener("dragend", _dropHandler, true);
            _dropHandler = null;
            setTimeout(function() {
              undo();
              setTimeout(function(){ _goto(idx + 1); }, 300);
            }, 500);
          };
          document.addEventListener("dragend", _dropHandler, true);
        }
      }, 250);
    }, 500);
  }

  /* ── End tour ──────────────────────────────────────────────── */
  function _end(completed) {
    _active = false;
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    if (_globalClick) {
      document.removeEventListener("click", _globalClick, true);
      _globalClick = null;
    }
    if (_dropHandler) {
      document.removeEventListener("dragend", _dropHandler, true);
      _dropHandler = null;
    }
    ["_dmbTourOverlay","_dmbTourRing","_dmbTourCard",
     "_dmbTourCursor","_dmbTourGraphic","_dmbTourStyle"].forEach(function(id){
      var e = document.getElementById(id); if (e) e.remove();
    });
    try { localStorage.setItem(TOUR_KEY, "1"); } catch(e) {}
  }

  /* ── Public API ────────────────────────────────────────────── */
  window.dmbStartTour = function() {
    try { if (localStorage.getItem(TOUR_KEY)) return; } catch(e) {}
    var builderEl = document.getElementById("step2");
    if (!builderEl || builderEl.style.display === "none") return;
    _active = true; _step = 0;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    _build();
    _goto(0);
  };

  window.dmbRestartTour = function() {
    try { localStorage.removeItem(TOUR_KEY); } catch(e) {}
    _end();
    setTimeout(function() {
      _active = true; _step = 0;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      _build();
      _goto(0);
    }, 150);
  };
})();
